/**
*!/usr/bin/env node
* -*- coding: utf-8 -*-
* Adewale Joshua Portfolio (AJP)
*/


/**
* author: OTechCup
* copyright: &copy; 2022 - new Date().getFullYear() All Rights Reserved | Exfac
* credits: ["Mr. O"]
* version: v0.1.0
* maintainer: OTechCup
* email: support@exfac.info
*/


// import modules
import React from "react";

import "../static/assets/css/Resume.css";


function Resume() {
  return (
    <section id="resume" className="resume">
      <div className="container">
        <div className="section-title">
          <h2>
            Resume
          </h2>

          <p>
            Check My Resume
          </p>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <h3 className="resume-title">
              Summary
            </h3>

            <div className="resume-item pb-0">
              <h4>
                Adewale Joshua
              </h4>

              <p>
                <em>
                  <b>
                    "I get excited about anything that involves solving problems, whether it's figuring out how to optimize a 
                    certain part of an existing application or entirely coming up with new applications to solve certain needs,
                    because problems in general stimulate my brain and give me a great sense of satisfaction."
                  </b>
                </em>
              </p>

              <p>
                <em>
                  My primary focus and inspiration for my studies is Artificial Intelligence Development. In my free time, I
                  study human computer interface and the psychology of human computer interaction. I'm both driven and
                  self-motivated and I'm constantly experimenting with new technologies and techniques. I'm very passionate
                  about Artificial Intelligence Development and strive to better myself in all my specialties and their
                  community as a whole.
                </em>
              </p>

              <p>
                <ul>
                  <li>
                    Kaduna, Nigeria.
                  </li>

                  <li>
                    (+234) 705-300-1118
                  </li>

                  <li>
                    adewale.o.joshua@gmail.com
                  </li>
                </ul>
              </p>
            </div>

            <h3 className="resume-title">
              Education
            </h3>

            <div className="resume-item">
              <h4>
                B.Sc Computer Science
              </h4>

              <h5>
                2017 - 2020
              </h5>

              <p>
                <em>
                  National Open University of Nigeria
                </em>
              </p>

              <p>
                Participated in hackathon with my coursemates and many more.
              </p>
            </div>

            <h3 className="resume-title">
              Reference
            </h3>

            <div className="resume-item">
              <p>
                Available on request.
              </p>
            </div>
          </div>

          <div className="col-lg-6">
            <h3 className="resume-title">
              Professional Experience
            </h3>

            <div className="resume-item">
              <h4>
                IT Professional
              </h4>

              <h5>
                2024 - Present
              </h5>

              <p>
                <em>
                  Foothold Academy
                </em>
              </p>

              <p>
                <ul>
                  <li>
                    Testing, installing and repairing hardware and software.
                  </li>

                  <li>
                    Maintaining computer systems.
                  </li>

                  <li>
                    And many more.
                  </li>
                </ul>
              </p>
            </div>

            <div className="resume-item">
              <h4>
                Software Engineer
              </h4>

              <h5>
                2023 - 2024
              </h5>

              <p>
                <em>
                  AveraMaximizer Inc.
                </em>
              </p>

              <p>
                <ul>
                  <li>
                    Create in-house mobile, web, and desktop applications.
                  </li>

                  <li>
                    Maintaining, updating, debugging and improve existing clients software.
                  </li>

                  <li>
                    Work closely with other team members of the development team and provide counsel on all aspects of the
                    project.
                  </li>

                  <li>
                    Perform code reviews.
                  </li>

                  <li>
                    Coaching junior developers.
                  </li>
                </ul>
              </p>
            </div>

            <div className="resume-item">
              <h4>
                Full Stack Developer
              </h4>

              <h5>
                2023 - 2024
              </h5>

              <p>
                <em>
                  Eduglobe Consultants
                </em>
              </p>

              <p>
                <ul>
                  <li>
                    Create in-house mobile, web, and desktop applications.
                  </li>

                  <li>
                    Maintaining, updating, debugging and improve existing clients software.
                  </li>

                  <li>
                    Work closely with other team members of the development team and provide counsel on all aspects of the
                    project.
                  </li>

                  <li>
                    Perform code reviews.
                  </li>

                  <li>
                    Coaching junior developers.
                  </li>
                </ul>
              </p>
            </div>

            <div className="resume-item">
              <h4>
                Full Stack Developer
              </h4>

              <h5>
                2022 - Present
              </h5>

              <p>
                <em>
                  Phoenix Information Technology
                </em>
              </p>

              <p>
                <ul>
                  <li>
                    Create in-house mobile, web, and desktop applications.
                  </li>

                  <li>
                    Maintaining, updating, debugging and improve existing clients software.
                  </li>

                  <li>
                    Work closely with other team members of the development team and provide counsel on all aspects of the
                    project.
                  </li>

                  <li>
                    Perform code reviews.
                  </li>

                  <li>
                    Coaching junior developers.
                  </li>
                </ul>
              </p>
            </div>

            <div className="resume-item">
              <h4>
                Software Engineer
              </h4>

              <h5>
                2021 - Present
              </h5>

              <p>
                <em>
                  Exfac Inc.
                </em>
              </p>

              <p>
                <ul>
                  <li>
                    Researching/investigating on new technologies, designing and creating computer software/frameworks to solve
                    real-world problems and executes the build.
                  </li>

                  <li>
                    Maintaining, testing, evaluating, upgrading, optimizing new/old software for speed, scalability and
                    identifying areas for modification, improving software built by other engineers to meet particular needs,
                    analyzing users' needs/requirements and developing programs to satisfy those needs, integrating existing
                    software products, get incompatible platforms to work together, monitoring and correcting software defects.
                  </li>

                  <li>
                    Writing and Performing code reviews/audit, refining and rewriting it as necessary and communicate with any
                    programmers involved in the project.
                  </li>

                  <li>
                    Consulting clients, engineers, security specialists, colleagues and other stakeholders concerning the
                    maintenance and performance of software systems, with a view to writing or modifying current software
                    systems.
                  </li>

                  <li>
                    Coaching junior developers.
                  </li>

                  <li>
                    Presenting new features to stakeholders and internal customers.
                  </li>

                  <li>
                    Create systems to control the scheduling of jobs or to control the access allowed to users or remote systems
                    and write operational documentation with technical authors.
                  </li>

                  <li>
                    Working closely with other staff, such as project managers, graphic designers, UX designers, other
                    developers, systems analysts, sales and marketing professionals.
                  </li>

                  <li>
                    Applying engineering principles and knowledge of programming languages to build software solutions for end
                    users.
                  </li>
                </ul>
              </p>
            </div>

            <div className="resume-item">
              <h4>
                Graphic Design Specialist
              </h4>

              <h5>
                2019 - 2021
              </h5>

              <p>
                <em>
                  Myraid Instinct Graphics
                </em>
              </p>

              <p>
                <ul>
                  <li>
                    Help clients communicate an appealing image through digital, electronic, and print media.
                  </li>

                  <li>
                    Use digital illustration, photo editing software and layout software to create designs.
                  </li>

                  <li>
                    Meet with clients or the art director to determine the scope of any project.
                  </li>

                  <li>
                    Create visual elements such as logos, original images and illustrations to help deliver a message.
                  </li>

                  <li>
                    Incorporates graphics into advertising and marketing campaigns, films, packaging and other promotional
                    materials.
                  </li>
                </ul>
              </p>
            </div>

            <div className="resume-item">
              <h4>
                IT Professional
              </h4>

              <h5>
                2018 - Present
              </h5>

              <p>
                <em>
                  Chartered Institute of Information and Strategy Management
                </em>
              </p>

              <p>
                <ul>
                  <li>
                    Developed numerous marketing programs (logos, brochures, infographics, presentations, and advertisements)
                    etc.
                  </li>

                  <li>
                    Managed up to 5 or even more projects or tasks at a given time while under pressure.
                  </li>

                  <li>
                    Maintaining computer networks and systems.
                  </li>

                  <li>
                    Building, testing, installing and repairing hardware and software.
                  </li>

                  <li>
                    Supervise the assessment of all graphic materials in order to ensure quality and accuracy of the design.
                  </li>
                </ul>
              </p>
            </div>

            <div className="resume-item">
              <h4>
                IT Professional
              </h4>

              <h5>
                2017 - Present
              </h5>

              <p>
                <em>
                  Globacom Limited
                </em>
              </p>

              <p>
                <ul>
                  <li>
                    Testing, installing and repairing hardware and software.
                  </li>

                  <li>
                    Maintaining computer systems.
                  </li>

                  <li>
                    And many more.
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};


export default Resume;
